import { render, staticRenderFns } from "./Pro_menu.vue?vue&type=template&id=aba0d758&scoped=true&"
import script from "./Pro_menu.vue?vue&type=script&lang=js&"
export * from "./Pro_menu.vue?vue&type=script&lang=js&"
import style0 from "./Pro_menu.vue?vue&type=style&index=0&id=aba0d758&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba0d758",
  null
  
)

export default component.exports